export function setSelectMenu(payload) {
  return {
    type: 'SELECT_MENU',
    payload,
  }
}
